<div class="organization-modal modal-content" piqetAngularDraggable>
  <div class="modal-header">
    <span class="bootstrap-dialog-title">{{ modalLabel }} </span>

    <button type="button" class="closeModal pull-right" aria-label="Close" (click)="onClose()">
      <img src="./assets/icons/pop-up-cross.svg" width="16" height="17" />
    </button>
  </div>

  <div class="modal-body body-modal">
    <form [formGroup]="productPackagingAddEditForm">
      <div class="row">
        <div class="col-sm-6">
          <div class="form-group required">
            <label
              *ngIf="
                productPackagingAddEditForm.get('sectorIdentifier')?.value ||
                productPackagingAddEditForm.get('region')?.value
              "
              class="sub-header-drpdown pb-2"
              >Sector Identifier</label
            >
            <ng-select
              [clearable]="true"
              [clearOnBackspace]="false"
              class="accordion-text addScroll"
              [virtualScroll]="true"
              #sectorIdentifier
              [readonly]="isDisabledDropDown"
              [items]="sectorIdentifierList"
              [searchable]="false"
              bindLabel="name"
              formControlName="sectorIdentifier"
              [searchFn]="commonInputSearch"
              placeholder="Identifier *"
              (change)="onChange($event)"
            >
              <ng-template ng-header-tmp>
                <div class="has-feedback">
                  <input
                    type="text"
                    class="accordion-search form-control search-input"
                    id="inputValidation"
                    (input)="sectorIdentifier.filter($any($event.target).value)"
                    placeholder="Search..."
                  />
                  <span class="form-control-feedback">
                    <i class="fa fa-search icon"></i>
                  </span>
                </div>
              </ng-template>
              <ng-template ng-option-tmp let-item="item" let-search="searchTerm">
                <div [ngOptionHighlight]="search" title="{{ item?.name }}">{{ item.name }}</div>
              </ng-template>
              <ng-template ng-optgrpup-tmp let-item="item" let-search="searchTerm">
                <div [ngOptionHighlight]="search" title="{{ item?.name }}">{{ item.name }}</div>
              </ng-template>
            </ng-select>
            <div
              *ngIf="
                (submitted || productPackagingAddEditForm.controls['sectorIdentifier']?.touched) &&
                productPackagingAddEditForm.controls['sectorIdentifier']?.invalid
              "
              class="input-error"
            >
              Sector identifier is required.
            </div>
          </div>
        </div>
        <div class="col-sm-6">
          <div class="form-group required">
            <label
              *ngIf="
                productPackagingAddEditForm.get('sectorIdentifier')?.value ||
                productPackagingAddEditForm.get('region')?.value
              "
              class="sub-header-drpdown pb-2"
              >Region</label
            >
            <ng-select
              [clearable]="true"
              [clearOnBackspace]="false"
              #region
              [items]="regionData"
              [readonly]="isDisabledDropDown"
              [searchable]="false"
              bindLabel="name"
              formControlName="region"
              [searchFn]="commonInputSearch"
              placeholder="Region *"
            >
              <ng-template ng-header-tmp>
                <div class="has-feedback">
                  <input
                    type="text"
                    class="form-control accordion-search search-input"
                    id="inputValidation"
                    (input)="region.filter($any($event.target).value)"
                    placeholder="Search..."
                  />
                  <span class="form-control-feedback">
                    <i class="fa fa-search icon"></i>
                  </span>
                </div>
              </ng-template>
              <ng-template ng-option-tmp let-item="item" let-search="searchTerm">
                <div [ngOptionHighlight]="search" title="{{ item?.name }}">{{ item.name }}</div>
              </ng-template>
            </ng-select>
            <div
              *ngIf="
                (productPackagingAddEditForm.controls['region']?.touched &&
                  productPackagingAddEditForm.controls['region']?.invalid) ||
                productPackagingAddEditForm.controls['region'].value?.name ===
                  '--Select Region-- ' ||
                (submitted && !productPackagingAddEditForm.controls['region'].value?.name)
              "
              class="input-error"
            >
              Region is required.
            </div>
          </div>
        </div>
      </div>
    </form>
    <form [formGroup]="productPackagingForm">
      <div class="row">
        <div class="col-sm-4" *ngFor="let formData of indicatorList">
          <div class="form-group required" aria-required="true">
            <div class="services-form">
              <input
                [formControlName]="formData.name"
                type="number"
                maxlength="30"
                oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);"
                placeholder="{{ formData.name }} ({{ formData.unit }})"
              />
              <label>{{ formData.name }} ({{ formData.unit }})</label>
              <div *ngIf="submitted && productPackagingForm.get(formData.name)?.invalid">
                <div class="input-error">Default value is required</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="setButtonAndError text-margin">
        <div class="modal-footer">
          <button type="button" class="cancelBtn" (click)="onClose()">Cancel</button>
          <button type="button" class="modelBtn purpleBtnHoverEffect" (click)="onSave()">
            Save
          </button>
        </div>

        <div
          class="redErrorTag"
          *ngIf="
            submitted && (this.productPackagingAddEditForm.invalid || productPackagingForm.invalid)
          "
        >
          <div class="bigScreenErrContain">
            <div>
              <span> <img src="./assets/icons/swalDeletion.svg" width="53" height="48" /></span>
            </div>
            <div>
              <div class="mb-3">
                <span>To proceed please complete the following fields : </span>
              </div>
              <div class="topBottomCss">
                <div
                  *ngIf="
                    (productPackagingAddEditForm.controls['sectorIdentifier']?.touched ||
                      submitted) &&
                    productPackagingAddEditForm.controls['sectorIdentifier']?.invalid
                  "
                >
                  Sector identifier
                </div>
              </div>
              <div class="topBottomCss">
                <div
                  *ngIf="
                    (productPackagingAddEditForm.controls['region']?.touched &&
                      productPackagingAddEditForm.controls['region']?.invalid) ||
                    productPackagingAddEditForm.controls['region'].value?.name ===
                      '--Select region-- ' ||
                    (submitted && !productPackagingAddEditForm.controls['region'].value?.name)
                  "
                >
                  Region
                </div>
              </div>
              <div class="topBottomCss" *ngIf="productPackagingForm.invalid">
                <div>Default value</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
</div>
